import { IsArray, IsBoolean, IsOptional, IsString } from "class-validator";
import { CostDocumentItemsPairSimple } from "./CostDocumentItemsPairs";
import { Expose } from "class-transformer";

export class CostDocumentSettledResult {
  @IsOptional()
  @IsString()
  @Expose()
  message!: string | null;
  @IsBoolean()
  @Expose()
  showExtendedMessage!: boolean;
  @IsArray()
  @Expose()
  costDocumentItemPairList: Array<CostDocumentItemsPairSimple> = [];
}
